
export const CoreDI = {
    Installer: Symbol('SystemComponents'),
    GameConfig: Symbol('GameConfig'),
    EnvironmentProperty: Symbol('EnvironmentProperty'),
    Settings: Symbol('Settings'),
    Browser: Symbol('Browser'),
    System: Symbol('System'),
    UpdateManager: Symbol('UpdateManager'),
    Device: Symbol('Device'),
    ScreenManager: Symbol('ScreenManager'),
    ScreenManagerV2: Symbol('ScreenManagerV2'),
    ResponsiveManager: Symbol('ResponsiveManager'),
    UIPresetConfigProviderService: Symbol('UIPresetConfigProviderService'),
    ResponsiveLayoutService: Symbol('ResponsiveLayoutService'),
    SafeZoneService: Symbol('SafeZoneManager'),
    SpecialInfoZoneService: Symbol('SpecialInfoZoneService'),
    FullscreenManager: Symbol('FullscreenManager'),
    ResolutionManager: Symbol('ResolutionManager'),
    VisibilityManager: Symbol('VisibilityManager'),
    IEventManagerWithAsync: Symbol('EventManagerWithAsync'),
    StrictEventEmitter: Symbol('StrictEventEmitter'),
    SlotEventAdapter: Symbol('SlotEventAdapter'),
    ResourceLoader: Symbol('ResourceLoader'),
    LanguageService: Symbol('LanguageService'),
    CurrencyFormatter: Symbol('CurrencyFormatter'),
    KeyboardModule: Symbol('KeyboardModule'),
    ObjectBuilder: Symbol('ObjectBuilder'),
    DisplayObjectUtils: Symbol ('DisplayObjectUtils'),
    Keyboard: Symbol ('Keyboard'),
    CLI: Symbol ('CommandLineInterfaceService'),
    SpineUtils: Symbol ('SpineUtils'),
    SoundPlayer: Symbol ('SoundPlayer'),
    SoundManager: Symbol('SoundManager'),
    InputGestures: Symbol ('InputGestures')
};
